import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";
import {
  FormControl,
  FormControlProps,
  TextField,
  TextFieldProps,
  TextFieldVariants,
} from "@mui/material";
import { cssAttributeValue } from "Util/cssAttributeValue";

type TextFieldSuperProps = {
  variant?: TextFieldVariants;
} & Omit<TextFieldProps, "variant">;

export interface TextFieldCustomizedProps extends TextFieldSuperProps {
  disabled?: boolean;
  multiline?: boolean;
  error?: boolean;
  bordercolor?: string;
}

export interface FormControlCustomizedProps extends FormControlProps {}
export const FormControlCustomized: React.FC<FormControlCustomizedProps> = styled(
  FormControl
)<FormControlCustomizedProps>(() => {
  return {
    display: "flex",
    justifyContent: "flex-end",
  };
});

export const WrapperInfo = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  cursor: "help",
  "& > svg": {
    color: colors.gray500,
    fontSize: 14,
    fontWeight: 600,
  },
}));

export const WrapperLabel = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 4,
}));

export const TextFieldCustomized: React.FC<TextFieldCustomizedProps> = styled(
  TextField
)<TextFieldCustomizedProps>((props) => {
  const backgroundColor = cssAttributeValue({
    defaultValue: props.theme.palette.background.paper,
    disabledValue: props.theme.palette.grey[50],
    disabled: props.disabled,
  });

  return {
    "& input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active":
      {
        WebkitBoxShadow: "0 0 0 30px white inset !important",
        WebkitTextFillColor: "#667085",
      },
    "& .MuiOutlinedInput-root": {
      backgroundColor,
      height: !props?.multiline ? "40px !important" : undefined,
      borderRadius: "8px",
      fontFamily: "Manrope",
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "24px",
      "&:hover:not(.Mui-focused) fieldset": {
        borderColor: `${props.theme.palette.grey[400]} !important`,
      },
    },
  };
});

const styles = makeStyles(() => ({
  iconError: {
    marginRight: "5px",
    fontSize: "16px",
  },
  extraSmallIcon: {
    fontSize: "14px",
  },
  keyboardDatepickerIcon: {
    width: "14px",
    height: "14px",
  },
  formHelper: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "14px",
    lineHeight: "24px",
    color: "#D92D20",
    alignItems: "center",
    display: "flex",
    margin: 0,
  },
  label: {
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "24px",
    color: (props: { disabled?: boolean }) => (props?.disabled ? "#667085" : colors.brandBlue500),
  },
  required: {
    color: (props: { disabled?: boolean }) => (props?.disabled ? "#667085" : "#F04438"),
  },
}));

export default styles;
